import { defineComponent as r, computed as a, createElementBlock as d, openBlock as s, renderSlot as v } from "vue";
import { RAW_DIMENSION as i, getSize as c } from "./Icon.constant.js";
const m = ["aria-hidden", "aria-label", "height", "role", "viewBox", "width"], w = /* @__PURE__ */ r({
  name: "RevIcon",
  __name: "Icon",
  props: {
    size: { default: "24" },
    viewBox: { default: `0 0 ${i} ${i}` },
    alternativeText: { default: void 0 }
  },
  setup(e) {
    const t = e, o = a(() => c(t.size)), l = a(() => t.alternativeText ? "img" : void 0);
    return (n, u) => (s(), d("svg", {
      "aria-hidden": !e.alternativeText,
      "aria-label": e.alternativeText,
      fill: "currentColor",
      height: o.value,
      role: l.value,
      viewBox: e.viewBox,
      width: o.value,
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      v(n.$slots, "default")
    ], 8, m));
  }
});
export {
  w as default
};
